import { Controller } from "@hotwired/stimulus"

// Syncs the master "All" checkbox with per-group email preference checkboxes.
// Disabled (locked) preferences are left alone.
export default class extends Controller {
  static targets = ["all", "item"]

  toggleAll() {
    const checked = this.allTarget.checked

    this.enabledItems().forEach((checkbox) => {
      checkbox.checked = checked
    })
  }

  syncAll() {
    if (!this.hasAllTarget) return

    const items = this.enabledItems()
    if (items.length === 0) return

    this.allTarget.checked = items.every((checkbox) => checkbox.checked)
  }

  enabledItems() {
    return this.itemTargets.filter((checkbox) => !checkbox.disabled)
  }
}
